import { PasswordResetEditForm } from '@/pages/PasswordResets/EditForm'

type PlayerPasswordResetEditProps = {
  token: string
}

export default function PlayerPasswordResetEdit({ token }: PlayerPasswordResetEditProps) {
  return (
    <PasswordResetEditForm
      title="選手パスワード再設定"
      token={token}
      patchPath="/player/password_resets/:token"
    />
  )
}
